import * as AcquisitionStoreActions from "./acquisition.actions";
import * as AcquisitionStoreSelectors from "./acquisition.selectors";
import * as AcquisitionStoreReducer from "./acquisition.reducer";

export {
  AcquisitionStoreActions,
  AcquisitionStoreSelectors,
  AcquisitionStoreReducer,
};
